import api from "../lib/apiClient";

export const listEmployees = (params = {}) =>
  api.get("/employees", { params }).then((r) => r.data);

// `partnerId` is a branch id — chain-only. Omit it to get the chain's own
// head-office tree (or, for a branch login, its own tree — the API ignores
// the query for branches regardless).
export const getEmployeeTree = (partnerId) =>
  api
    .get("/employees/tree", { params: partnerId ? { partner: partnerId } : {} })
    .then((r) => r.data);

export const getEmployee = (id) =>
  api.get(`/employees/${id}`).then((r) => r.data);

export const createEmployee = (payload) =>
  api.post("/employees", payload).then((r) => r.data);

export const updateEmployee = (id, payload) =>
  api.patch(`/employees/${id}`, payload).then((r) => r.data);

export const deleteEmployee = (id) =>
  api.delete(`/employees/${id}`).then((r) => r.data);

// Salary is append-only history, not a plain field: §4.1 describes the value
// sent at create time as "the first salary revision, exactly as §11.1 does".
// It is not part of `PATCH /employees/:id`, and it is not a sub-resource here
// either — pay lives under its own collection. See api/payroll.js.
